module.exports = __webpack_public_path__ + "static/img/TRX.eb0a36e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TRX.png
// module id = kcMB
// module chunks = 2